import http from './httpService';

export function getServicePlans() {
	return http.get('ServicePlans');
}
